<div class="badge-container">
  <span class="badge-statut" [class]="'badge-' + variant" [title]="getTooltipText()"></span>
</div>
